import * as types from '../mutation-types';

// initial state
const state = {
  country: 'RU',
  language: 'ru',
  countries: [],
  languages: [],
  phoneCode: null,
  phoneMask: null,
  isAuthorized: false,
  referrer: null,
};

// getters
const getters = {
  getCountry: (state) => state.country,
  getCountries: (state) => state.countries,
  getLanguage: (state) => state.language,
  getLanguages: (state) => state.languages,
  getPhoneCode: (state) => state.phoneCode,
  getPhoneMask: (state) => state.phoneMask,
  getIsAuthorized: (state) => state.isAuthorized,
  getReferrer: (state) => state.referrer,
};

// mutations
const mutations = {
  [types.UPDATE_COUNTRY](state, payload) {
    state.country = payload;
  },
  [types.UPDATE_IS_AUTHORIZED](state, payload) {
    state.isAuthorized = payload;
  },
  [types.UPDATE_CONFIGURATION](state, payload) {
    state.isAuthorized = payload.IS_AUTHORIZED;
    state.countries = payload.COUNTRIES;
    state.languages = payload.LANGUAGES;
    state.phoneCode = payload.COUNTRIES[state.country].COUNTRY_CODE;
    state.phoneMask = payload.COUNTRIES[state.country].MASK;
  },
  [types.UPDATE_REFERRER](state, payload) {
    state.referrer = payload;
  },
};

// actions
const actions = {
  setCountry({ commit, state }, payload) {
    commit(types.UPDATE_COUNTRY, payload);
  },
  setConfiguration({ commit, state }, payload) {
    commit(types.UPDATE_CONFIGURATION, payload);
  },
  setIsAuthorized({ commit, state }, payload) {
    commit(types.UPDATE_IS_AUTHORIZED, payload);
  },
  setReferrer({ commit, state }, payload) {
    commit(types.UPDATE_REFERRER, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  strict: true,
  namespaced: true,
};
